// Component
import { Form, Row, Col } from 'react-bootstrap';
import RotatingText from './rotationText/rotationText';
import BlurText from './blurTitle/blurTitle';
// logo
import logo from './../../assets/img/logo.jpg';
import { CgDarkMode } from "react-icons/cg";
// context
import { useContext, useEffect, useState } from 'react';
import { Text } from '../../contexts/textContext/textContext';

export function Head({ themeMode, setThemeMode, SetText }) {

    const text = useContext(Text);
    const [characterLimit, SetCharacterLimit] = useState(false);
    const [timeToRead, setTimeToRead] = useState();

    // this use effect is for setting time to read state
    useEffect(() => {
        if (text.length === 0) {
            setTimeToRead('Approx. reading Time 0 minute');
        }
        else if (text.length < 50) {
            setTimeToRead('Approx. reading Time <1 minute');
        }
        else {
            const time = Math.floor(text.length / 50);
            setTimeToRead(`Approx. reading Time about ${time} minutes`);
        }

    }, [text]);

    // Function for Change Theme
    function ChangeTheme() {
        themeMode === 'dark' ?
            setThemeMode('light') :
            setThemeMode('dark')
    }
    // function for change textState for app Component
    function textInputhandler(e) {
        if (characterLimit) {
            if (e.target.value.length <= 500) {
                SetText(e.target.value.substring(0, 500).toLowerCase());
            }            
        }
        else{
            SetText(e.target.value.toLowerCase());
        }
    }

    return (
        <div>
            <div className='d-flex justify-content-between py-4'>
                <div>
                    <div className='d-flex align-items-center'>
                        <img src={logo} className='logo rounded rounded-5 me-2' alt="" />
                        <h2 className='d-flex'>
                            <RotatingText
                                texts={['Character', 'Word', 'Sentence', 'Character']}
                                mainClassName="px-2 sm:px-2 md:px-3 bg-cyan-300 overflow-hidden py-0.5 sm:py-1 md:py-2 justify-center rounded-lg"
                                staggerFrom={"last"}
                                initial={{ y: "100%" }}
                                animate={{ y: 0 }}
                                exit={{ y: "-120%" }}
                                loop={false}
                                staggerDuration={0.025}
                                splitLevelClassName="overflow-hidden pb-0.5 sm:pb-1 md:pb-1"
                                transition={{ type: "spring", damping: 30, stiffness: 400 }}
                                rotationInterval={2000}
                            />
                            <span>
                                Counter
                            </span>
                        </h2>
                    </div>
                </div>
                <div className='d-flex align-items-center'>
                    <div>
                        {/* شرط درون کلاس برای هندل کردن rotate دکمه هنگام تغییر تم می باشد */}
                        <CgDarkMode className={`changeThemeBtn ${themeMode === 'dark' && 'rotate'}`} onClick={ChangeTheme} size={40} />
                    </div>
                </div>
            </div>
            <div className='titleConainer text-center mx-auto w-100 mt-4'>
                <h1 className='display-1 fw-bold'>
                    <BlurText
                        text="Analyze your Text in real-time."
                        delay={200}
                        animateBy="words"
                        direction="top"
                        className="text-2xl mb-8"
                    />
                </h1>
            </div>
            <div>
                <div>
                    <Form.Group className="mb-3">
                        <Form.Control onChange={textInputhandler} as="textarea" rows={7} placeholder='Start Typing Here... (or paste your Text)' />
                    </Form.Group>
                </div>
                <div>
                    <Row className='g-3'>
                        <Col className='col-12 col-md-6'>
                            <div className='d-flex'>
                                <Form.Check id='1' style={{ cursor: 'pointer' }} className='me-2' type={'checkbox'} />
                                <label htmlFor="1" style={{ cursor: 'pointer' }} className='me-5'>Exclude Spaces</label>
                                <Form.Check id='2' style={{ cursor: 'pointer' }} className='me-2' type={'checkbox'} onChange={() => SetCharacterLimit(!characterLimit)} checked={characterLimit} />
                                <label htmlFor="2" style={{ cursor: 'pointer' }}>Set Character Limit (work's for 500 Character)</label>

                            </div>
                        </Col>
                        <Col className='col-12 col-md-6 text-start text-md-end'>
                            <div>
                                <span>
                                    {timeToRead}
                                </span>
                            </div>
                        </Col>
                    </Row>
                </div>
            </div>
        </div>
    );
}